import { useMemo } from "react"
import { Box, useTheme } from "@mui/material"
import { PageCard, PageCardContent } from "components/card"
import { ServiceCard } from "components/domains/service/ServiceCard"
import { EmptyData } from "components/EmptyData"
import { ServiceIcon } from "components/icons"
import { MotionDiv, showContent } from "components/motions"
import { SidebarMenu } from "components/navigation/SidebarMenu"
import { VenueSelector } from "components/VenueSelector"
import { AppNavigation as DefaultAppNavigation } from "containers/kiosk-h"
import { useTranslation } from "providers/i18n"
import { usePageSideBarLayout } from "providers/ui/hooks"
import { useVenue } from "providers/venue"
import { getIcon } from "utils/icon"
import { useService } from "hooks/service"

export const ServicesKioskHPage = ({
  Layout = Box,
  AppNavigation = DefaultAppNavigation,
}) => {
  const { t } = useTranslation({ defaultValue: null })
  const {
    evenColServices,
    oddColServices,
    hasData,
    locationVenueId,
    venueFilter,
    changeVenueFilter,
  } = useService()
  const { venues, isMultiVenueProject } = useVenue()
  const theme = useTheme()

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.service) || <ServiceIcon />,
    [theme]
  )

  const styleOverrides = theme.components?.[`ServicePage`]?.styleOverrides || {}
  const {
    gridContainer,
    gridItem,
    emptyDataContainer,
    venueSelector,
    pageCard,
    pageCardContent,
    contentWrapper,
  } = styleOverrides

  usePageSideBarLayout({
    sidebar: {
      open: false,
    },
  })

  return (
    //@ts-ignore
    <Layout
      aside={
        <PageCard>
          <SidebarMenu AppNavigation={AppNavigation} />
        </PageCard>
      }
    >
      <PageCard sx={pageCard}>
        <PageCardContent sx={pageCardContent}>
          <MotionDiv
            variants={showContent}
            initial="initial"
            animate="animate"
            sx={contentWrapper}
          >
            <>
              {hasData ? (
                <Box sx={gridContainer}>
                  <Box sx={gridItem}>
                    {evenColServices.map((service, index) => (
                      <ServiceCard
                        key={`service-even-item-${index}`}
                        data={service}
                      />
                    ))}
                  </Box>
                  <Box sx={gridItem}>
                    {oddColServices.map((service, index) => {
                      return (
                        <ServiceCard
                          key={`service-odd-item-${index}`}
                          data={service}
                        />
                      )
                    })}
                  </Box>
                </Box>
              ) : (
                <Box sx={emptyDataContainer}>
                  <EmptyData
                    icon={emptyIcon}
                    primary={t("No Services")}
                    secondary={t("Check Back Soon")}
                  />
                </Box>
              )}
            </>
            {isMultiVenueProject && (
              <Box sx={venueSelector}>
                <VenueSelector
                  selectedVenue={venueFilter}
                  venues={venues}
                  onClickVenue={changeVenueFilter}
                  currentVenue={locationVenueId}
                />
              </Box>
            )}
          </MotionDiv>
        </PageCardContent>
      </PageCard>
    </Layout>
  )
}
